import { withAuthenticationRequired } from "@auth0/auth0-react";
import React from "react";

import { useAuthOverride } from "../../util/authOverride";
import { Loading } from "../Loading";

// TODO: Restore this implementation when we have a better way to invite
// growers to the platform.
// const hasAuthenticatedOnce = LocalStorageService.getItem(
//   LocalStorageService.Keys.HAS_AUTHENTICATED_ONCE,
// );

type AuthenticationGuardProps = {
  Component: React.ComponentType<object>;
};

export const RedirectingAuthenticationGuard = ({
  Component,
}: AuthenticationGuardProps) => {
  // Since we are inviting users by creating their account and sending a change
  // password email, they have already 'signed up' and will need the login
  // screen even the first time they authenticate.
  // const screen_hint = hasAuthenticatedOnce ? "login" : "signup";
  const screen_hint = "login";

  const authOverrideToken = useAuthOverride();

  // If the user has an auth override token matching the current url,
  // they don't need to be authenticated via Auth0
  if (authOverrideToken) {
    return <Component />;
  }

  const GuardedComponent = withAuthenticationRequired(Component, {
    onRedirecting: () => <Loading />,
    loginOptions: { authorizationParams: { screen_hint } },
  });

  return <GuardedComponent data-component="RedirectingAuthenticationGuard" />;
};
